import Vue from "vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import App from "./LayoutSelector";
import VueTour from "vue-tour";
import money from "v-money";
Vue.use(VueTour);
Vue.use(money);
import i18n from "./i18n";

import ExtendasDatatable from "@extendas/extendas-datatable";
Vue.use(ExtendasDatatable);

import "@/plugins/axios";

// import all the filters which are defined in the index file
import "@/filters/index";

if (store.state.viewstate.firstVisit) {
  Vue.prototype.$http
    .get("/api/configuration/v1/login")
    .then(response => {
      store.commit("config/login", response.data);
      store.commit("viewstate/firstVisit", false);
      start();
    })
    // eslint-disable-next-line no-unused-vars
    .catch(() => {
      store.commit("viewstate/notify", {
        text: i18n.t("error.something_went_wrong"),
        color: "error"
      });
    });
} else {
  store.dispatch("config/login");
  start();
}

function start() {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount("#app");
}
